export enum Variants {
  Date = 'DATE',
  Otp = 'OTP',
}
